import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Vă mulțumim pentru evaluare!',
  text: 'Există ceva ce putem îmbunătăți? Împărtășiți-vă părerea cu noi.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Opinia dumneavoastră...'
      }
    ],
    submit: {
      label: 'Trimiteți'
    }
  }
};
